import { createFeature, createReducer, on } from '@ngrx/store';
import { DecipherMappingState } from './decipher-mapping-state.model';
import { DecipherMappingActions } from './decipher-mapping.actions';

const initialState: DecipherMappingState = {
  localeMappings: null,
  qualificationsByLocale: {},
  isLoading: false,
  savingLocale: null,
  error: null,
};

export const decipherMappingFeature = createFeature({
  name: 'decipherMapping',
  reducer: createReducer(
    initialState,

    on(DecipherMappingActions.load, (state) => ({
      ...state,
      isLoading: true,
      error: null,
    })),

    on(
      DecipherMappingActions.loadSuccess,
      (state, { localeMappings, qualificationsByLocale }) => ({
        ...state,
        localeMappings,
        qualificationsByLocale,
        isLoading: false,
        error: null,
      }),
    ),

    on(DecipherMappingActions.loadFailure, (state, { error }) => ({
      ...state,
      isLoading: false,
      error,
    })),

    on(DecipherMappingActions.save, (state, { locale }) => ({
      ...state,
      savingLocale: locale,
      error: null,
      isLoading: false,
    })),

    on(DecipherMappingActions.saveSuccess, (state, { locale, mappings }) => ({
      ...state,
      savingLocale: null,
      localeMappings: (state.localeMappings ?? []).map((localeMapping) =>
        localeMapping.locale === locale
          ? { locale, questionMappings: mappings }
          : localeMapping,
      ),
      error: null,
      isLoading: false,
    })),

    on(DecipherMappingActions.saveFailure, (state, { error }) => ({
      ...state,
      savingLocale: null,
      error,
      isLoading: false,
    })),
  ),
});
